import { render, staticRenderFns } from "./AppHome.vue?vue&type=template&id=13b60bb1&"
import script from "./AppHome.vue?vue&type=script&lang=js&"
export * from "./AppHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports